import { Intent, Spinner } from "@blueprintjs/core";
import autobind from "autobind-decorator";
import { Component } from "react";
import omit from "lodash/omit";

import { Query } from "core/api/typedQuery";
import EntityForm from "core/components/EntityForm";
import TokenSession from "../../../../core/util/session/TokenSession";
import { UserSubscription } from "../../entity/UserSubscription";
import { ForumToaster } from "../../forumActions";


interface IUserSubscriptionFormProps {
	targetUserId: number; // if topic id is undefined we set the
	onAfterSave?: (topic: UserSubscription) => void;
}

const SubQuery = Query.queryMany<UserSubscription, {targetUserId: number}>(UserSubscription);

export default class UserSubscriptionForm extends Component<IUserSubscriptionFormProps> {

	constructor(props) {
		super(props);
	}

	@autobind
	private onBeforeSave(sub: UserSubscription) {
		const s = {...sub};
		
		s.targetUser = this.props.targetUserId;

		// temp. sservice should do this automatically on backend
		s.user = TokenSession.getUserId();

		s.id = null; // to avoid users subscriptions getting overwritten.

		// temp. service should accept same data type for query and mutation
		return omit(s, "targetUserEntity");
	}

	@autobind
	public onAfterSave(result: UserSubscription) {

		ForumToaster.show({
			intent: Intent.SUCCESS,
			message: "User subscription updated"
		});

		if(this.props.onAfterSave) {
			this.props.onAfterSave(result);
		}
	}

	public render() {
		return (
			<SubQuery params={{targetUserId: this.props.targetUserId}}>
				{
					({data, loading}) => loading ? (
						<Spinner />
					) : (
						<EntityForm instance={data && data.length && data[0]} clazz={UserSubscription} refetch={false} beforeSave={this.onBeforeSave} afterSave={this.onAfterSave} />
					)
				}
			</SubQuery>
		);
	}
}




// WEBPACK FOOTER //
// ./src/panels/forum/component/subscriptions/UserSubscriptionForm.tsx